export function isLoginLocation(location) {
  return location && location.pathname && location.pathname === "/login";
}

export function isProtectedLocation(location) {
  return !isLoginLocation(location);
}